<template>
  <div class="order-list">
    <div v-for="cellItem in orderList" :key="cellItem.id" class="order-item">
      <van-cell-group>
        <van-cell
          v-for="item in cellList"
          :key="item.value"
          :border="item.border || false"
          :title="item.title"
          :value="cellItem[item.value] || '--'"
        >
          <template v-if="item.filter && typeof item.filter === 'function'">
            {{ item.filter(cellItem[item.value], cellItem) || '--' }}
          </template>
          <!-- 单元格右侧 value 的内容 -->
          <template v-if="item.slot">
            <slot :name="item.slot" :item="cellItem" />
          </template>
        </van-cell>
      </van-cell-group>
      <!-- 表格底部操作栏 -->
      <slot name="order-footer" :item="cellItem" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderList',
  props: {
    cellList: {
      type: Array,
      required: true
    },
    orderList: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="less" scoped>
.order-list { margin-top: 15px;
  .order-item { margin-bottom: 10px;
  .van-cell-group {
    &::after { display: none; }
    .van-cell { padding: 0 16px; font-size: 12px; color: #aaa; justify-content: space-between;
      &__title,
      &__value { flex: none; max-width: calc(~'100vw - 120px') }
      &:first-of-type {
        padding: 10px 16px;
        margin-bottom: 5px;
        font-weight: 400;
        font-size: 14px;
        color: #333;
      }
    }
  }
  .order-footer { position: relative; height: 40px;
    &::after {
      position: absolute;
      content: '';
      width: 100%;
      height: 1px;
      top: 0;
      left: 0;
      right: 0;
      border-top: 1px solid #ebedf0;
      transform: scaleY(0.5);
    }
    /deep/ .van-col {
      height: 100%;
      &:first-of-type {
        .van-button {
          &::after {
            content: '';
            position: absolute;
            height: 100%;
            right: 0;
            top: 0;
            bottom: 0;
            border-right: 1px solid #ebedf0;
            transform: scaleX(0.5);
          }
        }
      }
    }
    /deep/ .van-button { width: 100%; height: 100%; border: none; color: #169BD5; padding: 0; }
  }
}
}
</style>